import { useState } from 'react';

export default function GalleryContact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.message) return;
    if (formData.message.length > 500) return;

    setSubmitting(true);
    try {
      const body = new URLSearchParams();
      body.append('name', formData.name);
      body.append('email', formData.email);
      body.append('message', formData.message);

      await fetch('https://readdy.ai/api/form/d6e2nmeqd308q1a0abs0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString()
      });

      setSubmitted(true);
      setFormData({ name: '', email: '', message: '' });
      setTimeout(() => setSubmitted(false), 4000);
    } catch {
      // silently handle
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="py-24 bg-neutral-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url("https://public.readdy.ai/ai/img_res/b1c1ccab2c138bb1744d3b78ad0847a4.jpg")'
          }}
        ></div>
      </div>

      <div className="relative max-w-4xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-block border border-amber-600 px-5 py-2 mb-6">
            <span className="text-amber-500 text-xs font-bold uppercase tracking-widest">Encargos</span>
          </div>
          <h2
            className="text-3xl md:text-5xl font-bold text-white mb-4"
            style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '2px' }}
          >
            ¿TE INTERESA UNA <span className="text-amber-500">OBRA PERSONALIZADA</span>?
          </h2>
          <p className="text-neutral-400 text-sm md:text-base max-w-xl mx-auto">
            Si te gusta mi trabajo de arte urbano y quieres encargar una pieza personalizada, escríbeme y hablamos.
          </p>
        </div>

        <form
          id="gallery-contact-form"
          data-readdy-form
          onSubmit={handleSubmit}
          className="max-w-lg mx-auto space-y-5"
        >
          <div>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Tu nombre"
              required
              className="w-full bg-neutral-800/60 border border-neutral-700 text-white placeholder-neutral-500 px-5 py-3.5 text-sm focus:outline-none focus:border-amber-600 transition-colors rounded"
            />
          </div>
          <div>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Tu email"
              required
              className="w-full bg-neutral-800/60 border border-neutral-700 text-white placeholder-neutral-500 px-5 py-3.5 text-sm focus:outline-none focus:border-amber-600 transition-colors rounded"
            />
          </div>
          <div>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Cuéntame tu idea..."
              required
              maxLength={500}
              rows={5}
              className="w-full bg-neutral-800/60 border border-neutral-700 text-white placeholder-neutral-500 px-5 py-3.5 text-sm focus:outline-none focus:border-amber-600 transition-colors rounded resize-none"
            ></textarea>
            <p className="text-neutral-600 text-xs mt-1 text-right">{formData.message.length}/500</p>
          </div>

          <button
            type="submit"
            disabled={submitting}
            className="w-full py-4 bg-amber-600 hover:bg-amber-700 text-white text-sm font-bold uppercase tracking-wider transition-all cursor-pointer whitespace-nowrap disabled:opacity-50"
            style={{ clipPath: 'polygon(8px 0, 100% 0, 100% calc(100% - 8px), calc(100% - 8px) 100%, 0 100%, 0 8px)' }}
          >
            {submitting ? (
              <span className="flex items-center justify-center gap-2">
                <i className="ri-loader-4-line animate-spin"></i> Enviando...
              </span>
            ) : (
              <span>
                <i className="ri-send-plane-line mr-2"></i> Enviar Mensaje
              </span>
            )}
          </button>

          {submitted && (
            <div className="flex items-center justify-center gap-2 text-green-400 text-sm py-3 bg-green-400/10 rounded">
              <i className="ri-check-line"></i>
              ¡Mensaje enviado! Te responderé pronto.
            </div>
          )}
        </form>
      </div>
    </section>
  );
}
